import { ReactNode } from 'react';
import OverviewPageLoadable from './SideMenuPages/OverviewPage/OverviewPageLoadable';
import { ValueOf } from '../../types';
import SettingsPageLoadable from './SideMenuPages/SettingsPage/SettingsPageLoadable';
import VerifyPageLoadable from './SideMenuPages/VerifyPage/VerifyPageLoadable';
import CommunityPageLoadable from './SideMenuPages/CommunityPage/CommunityPageLoadable';
import UserStatusesPageLoadable from './SideMenuPages/UserStatusesPage/UserStatusesPageLoadable';
import GloryArenaPageLoadable from './SideMenuPages/GloryArenaPage/GloryArenaPageLoadable';
import TutorialVideoPageLoadable from './SideMenuPages/TutorialVideoPage/TutorialVideoPageLoadable';
import HistoryPageLoadable from './SideMenuPages/HistoryPage/HistoryPageLoadable';
import HistoryInfoPageLoadable from './SideMenuPages/HistoryInfoPage/HistoryInfoPageLoadable';
import MarketPageLoadable from './SideMenuPages/MarketPage/MarketPageLoadable';
import CollectionPageLoadable from './SideMenuPages/CollectionPage/CollectionPageLoadable';
import ProfilePageLoadable from './SideMenuPages/ProfilePage/ProfilePageLoadable';
import { IMobileAppRootState } from '../../mobileAppCore/types/mobileAppState.t';
import { getIsBeginnersGuideEnabledSelector } from '../Tutorials/tutorialsSelectors';
import { IRootState } from '../../app/types/rootReducers.t';
import ClientAgreement from '../Docs/ClientAgreement';
import PrivacyPolicy from '../Docs/PrivacyPolicy';
import AdvancedSettingsPageLoadable from './SideMenuPages/AdvancedSettingsPage/AdvancedSettingsPageLoadable';
import { getIsShowAccountEventIndicator } from '../Notifications/notificationsSelectors';
import AppearancePageLoadable from './SideMenuPages/AppearancePage/AppearancePageLoadable';
import { getIsColorThemeFeatureEnabledSelector } from '../ColorTheme/colorThemeSelectors';
import MobileAppAmazingLoadable from '../../mobileAppCore/pages/MobileAppReferralAmazing/MobileAppAmazingLoadable';
import ReferralsPageLoadable from '../Referral/components/ReferralsPage/ReferralsPageLoadable';
import ReferralRulesContentLoadable from '../Referral/components/ReferralRulesContent/ReferralRulesContentLoadable';
import TutorialsBeginnersGuidePage from './SideMenuPages/TutorialsBeginnersGuidePage/TutorialsBeginnersGuidePage';
import MobileAppLeaderboardPageLoadable from '../Leaderboard/MobileAppLeaderboardPageLoadable';
import OnboardingLeaderboardSideMenuLoadable from '../Leaderboard/Onboarding/OnboardingLeaderboardSideMenuLoadable';

export const SIDE_MENU_IDS = {
    ACADEMY: 'academy',
    ACADEMY_COURSE: 'academy-course',
    ACADEMY_LESSON: 'academy-lesson',
    ADVANCED_SETTINGS: 'advanced-settings',
    APPEARANCE: 'appearance',
    CLIENT_AGREEMENT: 'client-agreement',
    COLLECTION: 'collection',
    GLORY_ARENA: 'glory-arena',
    GRAND_TOP: 'grand-top',
    HISTORY: 'history',
    HISTORY_INFO: 'history-info',
    MARKET: 'market',
    LEADERBOARD: 'leaderboard',
    LEADERBOARD_ONBOARDING: 'leaderboard-onboarding',
    MOBILE_COMMUNITY: 'mobile-community',
    OVERVIEW: 'overview',
    PRIVACY_POLICY: 'privacy-policy',
    PROFILE: 'profile',
    REFERRAL: 'referral',
    REFERRAL_AMAZING: 'referral-amazing',
    REFERRAL_RULES: 'referral-rules',
    SETTINGS: 'settings',
    TUTORIALS: 'tutorials',
    TUTORIAL_VIDEO: 'tutorial-video',
    USER_STATUSES: 'user-statuses',
    VERIFY: 'verify',
} as const;

export interface ISideMenuConfigItem {
    childItems?: Array<ValueOf<typeof SIDE_MENU_IDS>>;
    icon: string;
    id: ValueOf<typeof SIDE_MENU_IDS>;
    isBottom?: boolean;
    isShowNotificationIndicatorSelector?: (state: IRootState | IMobileAppRootState) => boolean;
    isVisibleSelector?: (state: IRootState | IMobileAppRootState) => boolean;
    label: string;
}

export const SIDE_MENU_CONFIG: ISideMenuConfigItem[] = [
    {
        id: SIDE_MENU_IDS.MARKET,
        label: 'menu.market',
        icon: 'IcChartStatistic',
        childItems: [SIDE_MENU_IDS.COLLECTION],
    },
    {
        id: SIDE_MENU_IDS.HISTORY,
        label: 'lite_version.home.history',
        icon: 'IcClock',
        childItems: [SIDE_MENU_IDS.HISTORY_INFO],
    },
    {
        id: SIDE_MENU_IDS.OVERVIEW,
        label: 'lite_version.home.overview',
        icon: 'IcOverviewChart',
        isShowNotificationIndicatorSelector: getIsShowAccountEventIndicator,
    },
    {
        id: SIDE_MENU_IDS.PROFILE,
        label: 'menu.profile',
        icon: 'IcPerson',
        childItems: [SIDE_MENU_IDS.USER_STATUSES, SIDE_MENU_IDS.MOBILE_COMMUNITY, SIDE_MENU_IDS.VERIFY, SIDE_MENU_IDS.GLORY_ARENA, SIDE_MENU_IDS.APPEARANCE, SIDE_MENU_IDS.REFERRAL],
    },
    {
        id: SIDE_MENU_IDS.GRAND_TOP,
        label: 'menu.grand_top',
        icon: 'IcMedal',
        isVisibleSelector: () => false,
    },
    {
        id: SIDE_MENU_IDS.TUTORIALS,
        label: 'tutorials.academy',
        icon: 'IcBookClosed',
        childItems: [SIDE_MENU_IDS.TUTORIAL_VIDEO],
        isVisibleSelector: getIsBeginnersGuideEnabledSelector,
    },
    // TODO Академия ждет дизайн под десктоп
    // {
    //     id: SIDE_MENU_IDS.ACADEMY,
    //     label: 'menu.academy',
    //     icon: 'IcBookClosed',
    //     isVisibleSelector: getIsAcademyEnabledSelector,
    // },
    {
        id: SIDE_MENU_IDS.SETTINGS,
        label: '',
        icon: 'IcSettings',
        isBottom: true,
        childItems: [SIDE_MENU_IDS.ADVANCED_SETTINGS],
    },
];

export interface ISidePageContentValue {
    children?: ReactNode;
    isFullMode?: boolean;
    isVisibleSelector?: (state: IRootState | IMobileAppRootState) => boolean;
    parent?: ValueOf<typeof SIDE_MENU_IDS>;
    title?: string;
    withHeader?: boolean;
}

interface ISidePageContent {
    [key: string]: ISidePageContentValue;
}

export const SIDE_PAGE_CONTENT: ISidePageContent = {
    [SIDE_MENU_IDS.MARKET]: {
        children: <MarketPageLoadable/>,
        title: 'menu.market',
    },
    [SIDE_MENU_IDS.COLLECTION]: {
        children: <CollectionPageLoadable/>,
        title: '',
        parent: SIDE_MENU_IDS.MARKET,
    },
    [SIDE_MENU_IDS.HISTORY]: {
        children: <HistoryPageLoadable/>,
        title: 'lite_version.home.history',
    },
    [SIDE_MENU_IDS.HISTORY_INFO]: {
        children: <HistoryInfoPageLoadable/>,
        title: '',
        parent: SIDE_MENU_IDS.HISTORY,
    },
    [SIDE_MENU_IDS.OVERVIEW]: {
        children: <OverviewPageLoadable/>,
        title: 'lite_version.home.overview',
    },
    [SIDE_MENU_IDS.PROFILE]: {
        children: <ProfilePageLoadable/>,
        title: 'menu.profile',
    },
    [SIDE_MENU_IDS.USER_STATUSES]: {
        children: <UserStatusesPageLoadable/>,
        title: 'user_statuses.title',
        parent: SIDE_MENU_IDS.PROFILE,
    },
    [SIDE_MENU_IDS.GRAND_TOP]: {
        // TODO: Пока что нет задачи, тк нет страницыв в тч и на мобиле
        children: null,
        title: 'menu.grand_top',
    },
    [SIDE_MENU_IDS.SETTINGS]: {
        children: <SettingsPageLoadable/>,
        title: 'menu.settings',
    },
    [SIDE_MENU_IDS.ADVANCED_SETTINGS]: {
        children: <AdvancedSettingsPageLoadable/>,
        title: 'settings_modal.advanced_settings',
        parent: SIDE_MENU_IDS.SETTINGS,
    },
    [SIDE_MENU_IDS.MOBILE_COMMUNITY]: {
        children: <CommunityPageLoadable/>,
        title: 'community.header',
        parent: SIDE_MENU_IDS.PROFILE,
    },
    [SIDE_MENU_IDS.VERIFY]: {
        children: <VerifyPageLoadable/>,
        title: 'verify.title',
        parent: SIDE_MENU_IDS.PROFILE,
    },
    [SIDE_MENU_IDS.GLORY_ARENA]: {
        children: <GloryArenaPageLoadable/>,
        title: 'lite_version.home.glory_arena',
        parent: SIDE_MENU_IDS.PROFILE,
    },
    [SIDE_MENU_IDS.TUTORIALS]: {
        children: <TutorialsBeginnersGuidePage/>,
        title: 'tutorials.academy',
        isVisibleSelector: getIsBeginnersGuideEnabledSelector,
        isFullMode: true,
        withHeader: false,
    },
    [SIDE_MENU_IDS.TUTORIAL_VIDEO]: {
        children: <TutorialVideoPageLoadable/>,
        title: '',
        parent: SIDE_MENU_IDS.TUTORIALS,
        isVisibleSelector: () => false,
    },
    [SIDE_MENU_IDS.CLIENT_AGREEMENT]: {
        children: <ClientAgreement/>,
        title: '',
        parent: SIDE_MENU_IDS.SETTINGS,
    },
    [SIDE_MENU_IDS.PRIVACY_POLICY]: {
        children: <PrivacyPolicy/>,
        title: '',
        parent: SIDE_MENU_IDS.SETTINGS,
    },
    [SIDE_MENU_IDS.APPEARANCE]: {
        children: <AppearancePageLoadable/>,
        title: 'appearance.title',
        parent: SIDE_MENU_IDS.PROFILE,
        isVisibleSelector: getIsColorThemeFeatureEnabledSelector,
    },
    [SIDE_MENU_IDS.REFERRAL_AMAZING]: {
        children: <MobileAppAmazingLoadable/>,
        title: '',
    },
    [SIDE_MENU_IDS.REFERRAL]: {
        children: <ReferralsPageLoadable/>,
        title: 'referral.invited_friends',
        parent: SIDE_MENU_IDS.PROFILE,
    },
    // TODO Академия ждет дизайн под десктоп
    // [SIDE_MENU_IDS.ACADEMY]: {
    //     children: <AcademyLoadable/>,
    //     isVisibleSelector: getIsAcademyEnabledSelector,
    //     title: 'menu.academy',
    // },
    [SIDE_MENU_IDS.REFERRAL_RULES]: {
        children: <ReferralRulesContentLoadable/>,
        title: '',
        parent: SIDE_MENU_IDS.REFERRAL,
    },
    [SIDE_MENU_IDS.LEADERBOARD_ONBOARDING]: {
        children: <OnboardingLeaderboardSideMenuLoadable/>,
        title: 'leaderboard.title',
    },
    [SIDE_MENU_IDS.LEADERBOARD]: {
        children: <MobileAppLeaderboardPageLoadable/>,
        title: 'leaderboard.title',
    },
};
